import { useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../redux/SettingAction";
import { ApiStatusTypeEnum } from "../../../../../enumeration/ApiStatusTypeEnum";
import { TransferForm } from "./TransferForm";
import * as masterActions from "../../../../common/redux/MasterLayoutAction";
import { useState } from "react";
import { Overlay } from "../../../../common/components/Overlay";
import { useLocation, useNavigate } from "react-router-dom";

export const TransferDialog = ({
  setSwalProps,
  company,
  mainWallet,
  setIsUpdateBalance,
  defaultPromoId,
  setCompany,
}) => {
  const intl = useIntl();
  const [isDeposit, setIsDeposit] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [gameBalance, setGameBalance] = useState("");
  const [promoLock, setPromoLock] = useState("");
  const [promotionListsV2, setPromotionListsV2] = useState([]);
  const [promotionId, setPromotionId] = useState("");
  const formikRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);
  const switchClass = "col-6 cursor-pointer p-2 text-center fw-semibold switch";

  const dispatch = useDispatch();

  const getLastSelectedPromo = () =>
    promotionListsV2?.find((promo) => promo?.selected === "true");

  const saveValues = (queryParams) => {
    const newQuery = { ...queryParams, companycode: company.gamecode };

    const transferAction = isDeposit
      ? actions.companyGameBalanceTopUp({
          ...newQuery,
          action: "companygametopupV2",
        })
      : actions.companyGameBalanceWithdraw({
          ...newQuery,
          promotionid: undefined,
          action: "companygamewithdrawV2",
        });

    dispatch(transferAction).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setIsUpdateBalance((prev) => prev + 1);
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "transferSuccessfully" }),
          onConfirm: () => {
            formikRef.current?.resetForm();
            setCompany(undefined);
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  const getCompanyGameBalance = () => {
    if (company) {
      dispatch(
        actions.getCompanyGameBalance({
          companycode: company.gamecode,
          action: "membertargetbalanceV2",
          balanceonly: "false",
        })
      ).then((resp) => {
        formikRef.current?.resetForm();
        setIsDeposit(true);
        resp = resp.data;
        setGameBalance(resp.balance);
        setPromoLock(resp.promolock);
        setPromotionListsV2(resp.promotionListsV2);
        setPromotionId(resp.promotionid);
      });
    }
  };

  useEffect(() => {
    getCompanyGameBalance();
  }, [company]);

  const handleRemovePromo = () => {
    const promotionid = getLastSelectedPromo()?.promotionid ?? "";

    setIsLoading(true);
    dispatch(
      masterActions.requestRemovePromoStep1({
        action: "promosettlement_step1",
        promotionid,
        companycode: company.gamecode,
      })
    ).then((resp) => {
      resp = resp.data;
      setIsLoading(false);

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        if (resp.step2 === "true") {
          setSwalProps({
            show: true,
            icon: "question",
            title: intl.formatMessage({
              id: "confirmation",
            }),
            text: intl.formatMessage({ id: resp.message }),
            showCancelButton: true,
            onConfirm: () => {
              setIsLoading(true);
              dispatch(
                masterActions.requestRemovePromoStep2({
                  action: "promosettlement_step2",
                  promotionid,
                  companycode: company.gamecode,
                })
              ).then((resp) => {
                resp = resp.data;
                setIsLoading(false);

                if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
                  getCompanyGameBalance();
                  setIsUpdateBalance((prev) => prev + 1);
                  setSwalProps({
                    show: true,
                    icon: "success",
                    title: intl.formatMessage({ id: "success" }),
                    text: intl.formatMessage({
                      id: "requestRemovePromoSended",
                    }),
                  });
                } else {
                  handleError(resp.message);
                }
              });
            },
          });
        } else {
          handleError(resp.message);
        }
      } else {
        handleError(resp.message);
      }
    });
  };

  const handleError = (errMsg) => {
    setSwalProps({
      show: true,
      icon: "error",
      title: intl.formatMessage({ id: "error" }),
      text: errMsg,
    });
  };

  return (
    <>
      {isLoading && <Overlay />}
      <Modal
        show={!!company}
        onHide={() => {
          setCompany(undefined);
          if (location.state?.redirectTo) {
            navigate(location.state?.redirectTo);
          }
        }}
        centered
        data-bs-theme="dark"
        autoFocus={false}
        enforceFocus={false}
        restoreFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-white">
            {company ? company.gamename : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-white">
          {company && (
            <>
              <div className="p-3 custom-border-bottom">
                <div className="d-flex mb-3 custom-border rounded overflow-hidden">
                  <div
                    className={`${switchClass}`}
                    style={{
                      color: isDeposit ? "black" : "white",
                      border: `2px solid ${
                        isDeposit ? "#f5be09" : "transparent"
                      }`,
                      background: isDeposit ? "#f5be09" : "transparent",
                    }}
                    onClick={() => {
                      setIsDeposit(true);
                      formikRef.current.resetForm();
                    }}
                  >
                    {intl.formatMessage({ id: "deposit" })}
                  </div>
                  <div
                    className={`${switchClass}`}
                    style={{
                      color: !isDeposit ? "black" : "white",
                      border: `2px solid ${
                        !isDeposit ? "#f5be09" : "transparent"
                      }`,
                      background: !isDeposit ? "#f5be09" : "transparent",
                    }}
                    onClick={() => {
                      setIsDeposit(false);
                      formikRef.current.resetForm();
                    }}
                  >
                    {intl.formatMessage({ id: "withdraw" })}
                  </div>
                </div>
                <TransferForm
                  formikRef={formikRef}
                  saveValues={saveValues}
                  mainWallet={mainWallet}
                  gameBalance={gameBalance}
                  promoLock={promoLock}
                  isDeposit={isDeposit}
                  promotionListsV2={promotionListsV2}
                  promotionId={promotionId}
                  defaultPromoId={defaultPromoId}
                  rate={company ? company.gamerate : null}
                />
              </div>
              <div className="p-3 d-flex justify-content-end align-items-center">
                {settingState.actionsLoading && (
                  <div
                    className="spinner-border me-2"
                    role="status"
                    style={{ scale: "0.55" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
                {isDeposit && promotionId !== "" && (
                  <button
                    type="button"
                    disabled={settingState.actionsLoading}
                    className="btn btn-danger fw-bold px-3 text-font3 me-3 py-2"
                    onClick={handleRemovePromo}
                  >
                    {intl.formatMessage({ id: "removePromotion" })}
                  </button>
                )}

                <button
                  type="button"
                  disabled={settingState.actionsLoading}
                  className="btn btn-prim fw-bold px-3 text-font3"
                  style={{ color: "black", backgroundColor: "#f5be09" }}
                  onClick={() => formikRef.current.submitForm()}
                >
                  {intl.formatMessage({ id: "submit" })}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
